import React,{useCallback, useState,useEffect } from 'react'; 
import { Menubar } from 'primereact/menubar';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import {ADD_CHECK_LIST,UPDATE_CHECK_LIST} from '../constant';
import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import CheckListModal from '../components/ModalContent/CheckListModal';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import { useLocation } from 'react-router-dom';
import {menuItems} from '../menuItems'
//import Loader from '../components/loader/Loader';

export default function MenuBar({onClick,userRole}) {
    const dispatch = useDispatch();
    const location = useLocation();
    //console.log(location.pathname,"==path");
    
  //const loading = useSelector((state) => state.loader.loading);
    const [isHovered, setIsHovered] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const [checkListDetails,setCheckListDetails] = useState('');
    const [error, setError] = useState(false);
    //const [loading, setLoading] = useState(false); // Loading state
    const [isEdit, setIsEdit] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [activeMenu, setActiveMenu] = useState('Dashboard'); // Default active menu

    const handleMouseEnter = () => {
      setIsHovered(true);
    };
  
    const handleMouseLeave = () => {
      setIsHovered(false);
    };
//  Template for all items
    // const defaultMenuTemplate = (item, options) => (
    //     <a
    //         href={`/home/${item.route}`}
    //         className="p-menuitem-link"
    //         onClick={(e) => {
    //             e.preventDefault(); // avoid full page reload
    //            if (typeof options?.command === 'function') {
    //             options.command({ originalEvent: e, item });
    //         } // trigger your logic
    //         }}
    //     >
    //         {item.label}
    //     </a>
    // );

    const defaultMenuTemplate = (item, options) => (
  <a
    href={`/home/${item.route}`}
    className="p-menuitem-link"
    style={{ cursor: 'pointer', textDecoration: 'none', }}
    onClick={(e) => {
      e.preventDefault(); // prevent default navigation
      if (typeof options?.command === 'function') {
        options.command({ originalEvent: e, item });
      }
    }}
  >
    {item.label}
  </a>
);


    // 🔁 Recursively apply template
    const applyTemplateToMenu = (items, templateFn) => {
        return items.map(item => {
            const newItem = {
                ...item,
                template: item.command ? templateFn : undefined,
            };
            if (item.items) {
                newItem.items = applyTemplateToMenu(item.items, templateFn);
            }
            return newItem;
        });
    };


useEffect(() => {
       const activeMenuFromStorage = localStorage.getItem('activeMenu'); // Read activeMenu from localStorage

  if (activeMenuFromStorage) {
    setActiveMenu(activeMenuFromStorage); // Update activeMenu state
  } else {
    console.warn('No activeMenu found in localStorage.');
  }
  }, []);

  // Save activeMenu to localStorage whenever it changes
  useEffect(() => {
    if (activeMenu) {
      localStorage.setItem('activeMenu', activeMenu);
    }
  }, [activeMenu]);

  // Track current route and set active menu
  useEffect(() => {
    const currentRoute = location.pathname.replace('/home/', '');

    // On chat page: do not highlight any nav item
    if (currentRoute === 'chat' || location.pathname.includes('/chat')) {
      if (activeMenu !== '') {
        setActiveMenu('');
      }
      return;
    }

    // Find the menu item that matches the current route
    const findActiveMenu = (menuItems) => {
      for (const item of menuItems) {
        // Exact match
        if (item.route === currentRoute) {
          return item.title;
        }
        // Partial match for routes with parameters (e.g., passenger/edit/123 matches passenger/edit)
        if (currentRoute.startsWith(item.route + '/') || 
            (currentRoute.startsWith(item.route) && currentRoute.includes('?'))) {
          return item.title;
        }
        if (item.items) {
          for (const subItem of item.items) {
            // Exact match
            if (subItem.route === currentRoute) {
              return subItem.title;
            }
            // Partial match for routes with parameters or query parameters
            if (currentRoute.startsWith(subItem.route + '/') || 
                (currentRoute.startsWith(subItem.route) && currentRoute.includes('?'))) {
              return subItem.title;
            }
            // Handle deeply nested items (third level)
            if (subItem.items) {
              for (const deepItem of subItem.items) {
                // Exact match
                if (deepItem.route === currentRoute) {
                  return deepItem.title;
                }
                // Partial match for routes with parameters or query parameters
                if (currentRoute.startsWith(deepItem.route + '/') || 
                    (currentRoute.startsWith(deepItem.route) && currentRoute.includes('?'))) {
                  return deepItem.title;
                }
              }
            }
          }
        }
      }
      return 'Dashboard'; // Default to Dashboard if no match found
    };

    // Define menu items for both user roles
    const allMenuItems = [
      { route: 'dashboard', title: 'Dashboard' },
      { route: 'agency/list', title: 'Agency List' },
      { route: 'agency', title: 'Add Agency' },
      { route: 'agency/edit', title: 'Agency Edit' },
      { route: 'payer', title: 'Add Payer' },
      { route: 'payer/list', title: 'Payer List' },
      { route: 'payer/edit', title: 'Payer Edit' },
      { route: 'passenger', title: 'Add Passenger' },
      { route: 'passenger/list', title: 'Passenger List' },
      { route: 'passenger/edit', title: 'Passenger Edit' },
      { route: 'passenger/profile', title: 'Passenger Profile' },
      { route: 'driver', title: 'Add Driver' },
      { route: 'driver/list', title: 'Driver List' },
      { route: 'driver/edit', title: 'Driver Edit' },
      { route: 'driver/profile', title: 'Driver Profile' },
      { route: 'vehicle', title: 'Add Vehicle' },
      { route: 'vehicle/list', title: 'Vehicle List' },
      { route: 'vehicle/edit', title: 'Vehicle Edit' },
      { route: 'vehicle/maintenance/list', title: 'Vehicle Maintenance List' },
      { route: 'vehicle/report', title: 'Vehicle Report' },
      // { route: 'schedule', title: 'Schedule' },
      { route: 'schedule/list/v1', title: 'Schedule List' },
    //   { route: 'schedule/list', title: 'Schedule List' },
      { route: 'schedule/edit', title: 'Schedule Edit' },
      { route: 'schedule/upload', title: 'Schedule Upload' },
      { route: 'schedule/upload/history', title: 'Schedule Upload History' },
      { route: 'trip', title: 'Add Trip' },
      { route: 'trip/list/v1', title: 'Trip List' },
      { route: 'billing/list', title: 'Billing List' },
      { route: 'billing/submittedBatches', title: 'Submission Batch' },
      { route: 'billing/summaryList', title: 'Billing Summary' },
      { route: 'officeAdmin', title: 'Add Office Admin' },
      { route: 'officeAdmin/list', title: 'Office Admin List' },
      { route: 'officeAdmin/edit', title: 'Office Admin Edit' },
      { route: 'profile/myProfile', title: 'My Profile' },
      { route: 'updatedSchedule', title: 'Add Schedule-NEW' },
      { route: 'billing/bill-rate-configuration', title: 'Add Bill Rate' },
      { route: 'billing/bill-rate-list', title: 'Bill Rate List' },
      { route: 'ftp/credentials', title: 'Add FTP Credentials' },
      { route: 'ftp/credentials/list', title: 'FTP List' },
    ];

    const newActiveMenu = findActiveMenu(allMenuItems);
    if (newActiveMenu !== activeMenu) {
      setActiveMenu(newActiveMenu);
    }
  }, [location.pathname, activeMenu]);

    const navigate = useNavigate();
    let items = [];
    
    // Remove the problematic useEffect that was causing infinite loops
    // const handleItemClick = useCallback((event, title, route) => {
    //     console.log('Menu item clicked:', title, route);
    //     setActiveMenu(title); // Set the clicked menu as active
    //     onClick(title, route);
    //     console.log('Navigating to:', `/home/${route}`);
    //      navigate(`/home/${route}`, { replace: false }); // Use replace: false to add to browser history
    // }, [onClick,navigate]);

    const handleItemClick = (event, title, route) => {
        //console.log('Menu item clicked:', title, route);
        setActiveMenu(title); // Set the clicked menu as active
        onClick(title, route);
        //console.log('Navigating to:', `/home/${route}`);
         navigate(`/home/${route}`, { replace: false }); // Use replace: false to add to browser history
    };

    const isParentActive = (parentLabel, childLabels) => {
        // Check if any of the child labels match the active menu
        const hasActiveChild = childLabels.some(childLabel => activeMenu === childLabel);
        //console.log(`Parent ${parentLabel}: activeMenu=${activeMenu}, childLabels=${childLabels}, hasActiveChild=${hasActiveChild}`);
        return hasActiveChild ? 'active-menu-item' : '';
    };

    if(userRole === 1){
     //console.log('Admin user - activeMenu:', activeMenu);
     items = [
        {
            label: 'Dashboard',
            route: 'dashboard',
            title:'Dashboard',
            command: (event) => handleItemClick(event, 'Dashboard', 'dashboard'),
            className: (() => {
                const className = activeMenu === 'Dashboard' ? 'active-menu-item' : '';
                return className;
            })(),
        },
        {
            label: 'Agency',
            items: [
                {
                    label: 'Add Agency',
                    route: 'agency',
                    title:'Add Agency',
                    command: (event) => handleItemClick(event, 'Add Agency', 'agency'),
                    className: activeMenu === 'Add Agency' ? 'active-menu-item' : '',
                },
                {
                    label: 'Agency List',
                    route: 'agency/list',
                    title:'Agency List',
                    command: (event) => handleItemClick(event, 'Agency List', 'agency/list'),
                    className: activeMenu === 'Agency List' ? 'active-menu-item' : '',
                }
            ],
            className: isParentActive('Agency', ['Add Agency', 'Agency List', 'Agency Edit']),
        },
        {
            label: 'Payor',
            items: [
                {
                    label: 'Add Payor',
                    route: 'payer',
                    title:'Add Payer',
                    command: (event) => handleItemClick(event, 'Add Payer', 'payer'),
                    className: activeMenu === 'Add Payer' ? 'active-menu-item' : '',
                },
                {
                    label: 'Payor List',
                    route: 'payer/list',
                    title:'Payer List',
                    command: (event) => handleItemClick(event, 'Payer List', 'payer/list'),
                    className: activeMenu === 'Payer List' ? 'active-menu-item' : '',
                }
            ],
            className: isParentActive('Payer', ['Add Payer', 'Payer List', 'Payer Edit']),
        },
        // {
        //     label: 'Add User',
        //     route: 'adduser',
        //     title:'add user',
        //     command: (event) => handleItemClick(event, 'Add user', 'user')
        // },
        {
            label: 'Add Check List',
            route: 'addchecklist',
            command: () => openModal(),
            className: activeMenu === 'Add Check List' ? 'active-menu-item' : '',
        },
        {
            label: 'Bill Rate Configuration',
            items: [
                {
                    label: 'Add Bill Rate',
                    route: 'billing/bill-rate-configuration/v1',
                    title: 'Add Bill Rate',
                    command: (event) => handleItemClick(event, 'Add Bill Rate', 'billing/bill-rate-configuration/v1'),
                    className: activeMenu === 'Add Bill Rate' ? 'active-menu-item' : '',
                },
                // {
                //     label: 'Add Bill Rate',
                //     route: 'billing/bill-rate-configuration',
                //     title: 'Add Bill Rate',
                //     command: (event) => handleItemClick(event, 'Add Bill Rate', 'billing/bill-rate-configuration'),
                //     className: activeMenu === 'Add Bill Rate' ? 'active-menu-item' : '',
                // },
                {
                    label: 'Bill Rate List',
                    route: 'billing/bill-rate-list',
                    title: 'Bill Rate List',
                    command: (event) => handleItemClick(event, 'Bill Rate List', 'billing/bill-rate-list'),
                    className: activeMenu === 'Bill Rate List' ? 'active-menu-item' : '',
                }
            ],
            className: isParentActive('Bill Rate Configuration', ['Add Bill Rate', 'Bill Rate List']),
        },
        {
            label: 'FTP Settings',
            items: [
                {
                    label: 'Add FTP Credentials',
                    route: 'ftp/credentials',
                    title: 'Add FTP Credentials',
                    command: (event) => handleItemClick(event, 'Add FTP Credentials', 'ftp/credentials'),
                    className: activeMenu === 'Add FTP Credentials' ? 'active-menu-item' : '',
                },
                {
                    label: 'FTP List',
                    route: 'ftp/credentials/list',
                    title: 'FTP List',
                    command: (event) => handleItemClick(event, 'FTP List', 'ftp/credentials/list'),
                    className: activeMenu === 'FTP List' ? 'active-menu-item' : '',
                },
            ],
            className: isParentActive('FTP Settings', ['Add FTP Credentials', 'FTP List']),
        },
    ];
}else{
     //console.log('Regular user - activeMenu:', activeMenu);
     items = [
        {
            label: 'Dashboard',
            route: 'dashboard',
            title:'Dashboard',
            command: (event) => handleItemClick(event, 'Dashboard', 'dashboard'),
            className: activeMenu === 'Dashboard' ? 'active-menu-item' : '',
        },
        {
            label: 'Passenger',
            items: [
                {
                    label: 'Add Passenger',
                    route: 'passenger',
                    title:'Add Passenger',
                    command: (event) => handleItemClick(event, 'Add Passenger', 'passenger'),
                    className: activeMenu === 'Add Passenger' ? 'active-menu-item' : '',
                },
                {
                    label: 'Passenger List',
                    route: 'passenger/list',
                    title:'Passenger List',
                    command: (event) => handleItemClick(event, 'Passenger List','passenger/list'),
                    className: activeMenu === 'Passenger List' ? 'active-menu-item' : '',
                }
            ],
            className: isParentActive('Passenger', ['Add Passenger', 'Passenger List', 'Passenger Edit', 'Passenger Profile']),
        },
        {
            label: 'Employees',
            items: [
                {
                    label: 'Driver',
                    items: [
                        {
                            label: 'Add Driver',
                            route: 'driver',
                            title:'Add Driver',
                            command: (event) => handleItemClick(event, 'Add Driver','driver'),
                            className: activeMenu === 'Add Driver' ? 'active-menu-item' : '',
                        },
                        {
                            label: 'Driver List',
                            route: 'driver/list',
                            title:'Driver List',
                            command: (event) => handleItemClick(event, 'Driver List','driver/list'),
                            className: activeMenu === 'Driver List' ? 'active-menu-item' : '',
                        }
                    ],
                    className: isParentActive('Driver', ['Add Driver', 'Driver List', 'Driver Edit', 'Driver Profile']),
                },
                {
                    label: 'Office Admin',
                    items: [
                        {
                            label: 'Add Office Admin',
                            route: 'officeAdmin',
                            title:'Add Office Admin',
                            command: (event) => handleItemClick(event, 'Add Office Admin','officeAdmin'),
                            className: activeMenu === 'Add Office Admin' ? 'active-menu-item' : '',
                        },
                        {
                            label: 'Office Admin List',
                            route: 'officeAdmin/list',
                            title:'Office Admin List',
                            command: (event) => handleItemClick(event, 'Office Admin List','officeAdmin/list'),
                            className: activeMenu === 'Office Admin List' ? 'active-menu-item' : '',
                        }
                    ],
                    className: isParentActive('Office Admin', ['Add Office Admin', 'Office Admin List', 'Office Admin Edit']),
                }
            ],
            className: isParentActive('Employee', ['Add Driver', 'Driver List', 'Driver Edit', 'Driver Profile', 'Add Office Admin', 'Office Admin List', 'Office Admin Edit', 'My Profile']),
        },
        {
            label: 'Vehicle',
            items: [
                {
                    label: 'Add Vehicle',
                    route: 'vehicle',
                    title:'Add Vehicle',
                    command: (event) => handleItemClick(event, 'Add Vehicle','vehicle'),
                    className: activeMenu === 'Add Vehicle' ? 'active-menu-item' : '',
                },
                {
                    label: 'Vehicle List',
                    route: 'vehicle/list',
                    title:'Vehicle List',
                    toggleEvent: 'click',
                    command: (event) => handleItemClick(event, 'Vehicle List','vehicle/list'),
                    className: activeMenu === 'Vehicle List' ? 'active-menu-item' : '',
                    template: (item, options) => (
    <a
      href={`/home/${item.route}`}
      className="p-menuitem-link"
      style={{ textDecoration: 'none',}}
      onClick={(e) => {
        e.preventDefault(); // prevent full page reload
        options.command({ originalEvent: e, item }); // trigger your logic
      }}
    >
      {item.label}
    </a>)
                },
                {
                    label: 'Vehicle Maintenance List',
                    route: 'vehicle/maintenance/list',
                    title:'Vehicle Maintenance List',
                    command: (event) => handleItemClick(event, 'Vehicle Maintenance List','vehicle/maintenance/list'),
                    className: activeMenu === 'Vehicle Maintenance List' ? 'active-menu-item' : '',
                }
            ],
            className: isParentActive('Vehicle', ['Add Vehicle', 'Vehicle List', 'Vehicle Edit', 'Vehicle Maintenance List', 'Vehicle Report']),
        },
        {
            label: 'Schedule',
            items: [
                // {
                //     label: 'Add Schedule',
                //     route: 'schedule',
                //     title:'Schedule',
                //     command: (event) => handleItemClick(event, 'Schedule','schedule'),
                //     className: activeMenu === 'Schedule' ? 'active-menu-item' : '',
                // },
                {
                  label: 'Add Schedule',
                  route: 'updatedSchedule',
                  title:'Add Schedule',
                  command: (event) => handleItemClick(event, 'Add Schedule','updatedSchedule'),
                  className: activeMenu === 'Add Schedule' ? 'active-menu-item' : '',
              },
                // {
                //     label: 'Schedule List',
                //     route: 'schedule/list',
                //     title:'Schedule List',
                //     command: (event) => handleItemClick(event, 'Schedule List','schedule/list'),
                //     className: activeMenu === 'Schedule List' ? 'active-menu-item' : '',
                // },
                // new schedule list
                {
                    label: 'Schedule List',
                    route: 'schedule/list/v1',
                    title: 'Schedule List',
                    command: (event) => handleItemClick(event, 'Schedule List', 'schedule/list/v1'),
                    className: activeMenu === 'Schedule List (V1)' ? 'active-menu-item' : '',
                },
                {
                    label: 'Schedule Upload',
                    route: 'schedule/upload',
                    title:'Schedule Upload',
                    command: (event) => handleItemClick(event, 'Schedule Upload','schedule/upload'),
                    className: activeMenu === 'Schedule Upload' ? 'active-menu-item' : '',
                },
                {
                    label: 'Schedule Upload History',
                    route: 'schedule/upload/history',
                    title:'Schedule Upload History',
                    command: (event) => handleItemClick(event, 'Schedule Upload History','schedule/upload/history'),
                    className: activeMenu === 'Schedule Upload History' ? 'active-menu-item' : '',
                },
                // {
                //     label: 'Unassigned Schedules',
                //     route: 'schedule/unAssignedScheduleList',
                //     title:'Unassigned Schedule List',
                //     command: (event) => handleItemClick(event, 'Unassigned Schedules','schedule/unAssignedScheduleList'),
                //     className: activeMenu === 'Unassigned Schedules' ? 'active-menu-item' : '',
                // }
            ],
            //className: activeMenu === 'Schedule' ? 'active-menu-item' : '',
            className: isParentActive('Schedule', ['Schedule', 'Schedule List', 'Schedule List (V1)', 'Schedule Edit', 'Schedule Upload', 'Schedule Upload History', 'Add Schedule-NEW']),
        },
        {
            label: 'Trip',
            items: [
                {
                    label: 'Trip List',
                    route: 'trip/list/v1',
                    title:'Trip List',
                    command: (event) => handleItemClick(event, 'Trip List','trip/list/v1'),
                    className: activeMenu === 'Trip List' ? 'active-menu-item' : '',
                },
                {
                    label: 'Add Trip',
                    route: 'trip',
                    title:'Add Trip',
                    command: (event) => handleItemClick(event, 'Add Trip','trip'),
                    className: activeMenu === 'Add Trip' ? 'active-menu-item' : '',
                },
                
            ],
            className: isParentActive('Trip', ['Add Trip', 'Trip List']),
        },
        {
            label: 'Billing',
            items: [
                {
                    label: 'Billing List',
                    route: 'billing/list',
                    title:'Billing List',
                    command: (event) => handleItemClick(event, 'Billing List', 'billing/list'),
                    className: activeMenu === 'Billing List' ? 'active-menu-item' : '',
                },
                {
                    label: 'Submission Batch',
                    route: 'billing/submittedBatches',
                    title:'Submission Batch',
                    command: (event) => handleItemClick(event, 'Submission Batch', 'billing/submittedBatches'),
                    className: activeMenu === 'Submission Batch' ? 'active-menu-item' : '',
                },
                {
                    label: 'Billing Summary',
                    route: 'billing/summaryList',
                    title:'Billing Summary',
                    command: (event) => handleItemClick(event, 'Billing Summary', 'billing/summaryList'),
                    className: activeMenu === 'Billing Summary' ? 'active-menu-item' : '',
                }
            ],
            className: isParentActive('Billing', ['Billing List', 'Submission Batch', 'Billing Summary']),
        },
        
    ];
}
items = applyTemplateToMenu(items, defaultMenuTemplate);

const openModal = (isEditMode = false, initialValue = '') => {
    setIsEdit(isEditMode);
    setCheckListDetails(initialValue);
    setModalVisible(true);
};

const closeModal = () => {
    setModalVisible(false);
    setError(false); // Reset error state when modal is closed
};

const handleInputChange = (e) => {
    const { value } = e.target;
    setCheckListDetails(value);
};

      const handleLogoutClick = (event) => {
        localStorage.removeItem('userData');
        localStorage.removeItem('token');
        navigate('/');
      };

      const findItem = (items, label) => {
        for (const item of items) {
            if (item.label === label ) {
                
                return item;
            }
            if (item.items) {
                const foundItem = findItem(item.items, label);
                if (foundItem) {
                    return foundItem;
                }
            }
            
        }
        return null;
    };
    
      const handleContextMenu = (event) => {
       //event.preventDefault();
        const target = event.target;
        
       if (target && target.textContent) {
        const label = target.textContent;
        const selectedItem = findItem(items, label);
        if (selectedItem ) {
            if(selectedItem.label !== 'Passenger' && selectedItem.label !== 'Driver' && selectedItem.label !== 'Vehicle' && selectedItem.label !== 'Schedule'){
                const url = `${window.location.origin}/home/${selectedItem.route}`;
               window.open(url, '_blank');}
        }
         } 
      }; 

  
    const checkListForm =async(e)=>{
        //e.preventDefault();
        setError(false); // Reset error state on form submission
        //setLoading(true);
       
        try {
            dispatch(setLoading(true));
            if(checkListDetails){
                const response = isEdit 
                ? await axios.put(`${UPDATE_CHECK_LIST}/${checkListDetails.id}`, { check_list: checkListDetails }) // Assuming you have an ID for update
                : await axios.post(ADD_CHECK_LIST, { check_list: checkListDetails });
            //return false;
            //console.log(response.data.status);
            if (response.data.status === '200') {
                setSubmitted(false);
                setCheckListDetails('');
                setModalVisible(false);
                dispatch(setLoading(false));
                
                navigate('/home/checking/list', { replace: false }); // Use replace: false to add to browser history
                Swal.fire({
                  title: 'Success!',
                  text: response.data.message,
                  icon: 'success',
                  confirmButtonText: 'OK',
                });
            } else {
                 setModalVisible(false);
                dispatch(setLoading(false));
               
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message,
                    icon: 'Error',
                    confirmButtonText: 'OK',
                  });
                //console.log(response.data.message);
            }
        }else{
            setSubmitted(true);
            dispatch(setLoading(false));
        }
        } catch (error) {
            dispatch(setLoading(false));
            console.error("Error logging in:", error);
        }
    }
    return (
        <><div className="card border-0 nav-main" style={{boxShadow:'none'}}>
            <Menubar model={items} 
            onSelect={handleItemClick}
            
                className={isHovered ? 'hovered-button' : ''}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{
                    color: '#000 !important'
                }} />

            <CheckListModal
                visible={isModalVisible}
                onHide={closeModal}
                title={isEdit ? "Edit Check List" : "Add Check List"}
                inputValue={checkListDetails}
                isValid={submitted}
                setValid={setSubmitted}
                onInputChange={handleInputChange}
                onSave={checkListForm}
                
                isEdit={isEdit} />

        </div><div></div></>
    )
    
}
